export const LOAI_DOI_TUONG_CONST = {
  dichVu: { code: 1, name: "Dịch vụ" },
  bhyt: { code: 2, name: "BHYT" },
};
export const HINH_THUC = {
  benhMoi: { code: 1, name: "Bệnh mới" },
  taiKham: { code: 2, name: "Tái khám" },
};

export const HINH_THUC_ARRAY = [
  { code: 1, name: "Bệnh mới" },
  { code: 2, name: "Tái khám" },
];

export const UU_TIEN = {
  uuTien: { code: 1, name: "Ưu tiên" },
  khong: { code: 2, name: "Không" },
};

export const trangThaiBenhNhan = {
  dangKham: { code: 1, name: "Đang khám" },
  choKQ: { code: 2, name: "Chờ kết quả" },
  daCoKQ: { code: 3, name: "Đã có KQ" },
  ketThucKham: { code: 4, name: "Kết thúc khám" },
};

export const KEY_TAB_BENH_NHAN = {
  LICH_SU: "0",
  TT_XAC_THUC: "1",
};

export const KEY_TAB_THONG_TIN_KHAM_BENH = {
  DICH_VU: "0",
  HOI_BENH: "1",
  KHAM_BENH: "2",
  XET_NGHIEM: "3",
  CHAN_DOAN_HINH_ANH: "4",
  DON_THUOC: "5",
};
